module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_36-8c3e8cebd63c385ca1ce65482beb8f7c.png";